// extracted by mini-css-extract-plugin
module.exports = {"cardstyle":"Alert_cardstyle__wM2_X","slideBbottom":"Alert_slideBbottom__376N3","slide-bottom":"Alert_slide-bottom__3Dzix"};